import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'components/AppIcon';
import CompatibilityMatrix from './components/CompatibilityMatrix';
import ScenarioBuilder from './components/ScenarioBuilder';
import AssessmentResults from './components/AssessmentResults';
import ReferenceLiterature from './components/ReferenceLiterature';
import CompatibilitySearch from './components/CompatibilitySearch';

export default function CompatibilityAssessmentWorkspace() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('matrix');
  const [selectedChemical, setSelectedChemical] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [scenarioData, setScenarioData] = useState({
    temperature: 25,
    pressure: 1,
    concentration: 100,
    duration: 24,
  });

  const tabs = [
    { id: 'matrix', label: 'Compatibility Matrix', icon: 'Grid' },
    { id: 'scenario', label: 'Scenario Builder', icon: 'Settings' },
    { id: 'assessment', label: 'Assessment Results', icon: 'FileText' },
    { id: 'references', label: 'Reference Literature', icon: 'BookOpen' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Chemical Compatibility Matrix Manager</h1>
              <p className="text-sm text-gray-600 mt-1">Assess chemical-chemical and chemical-material compatibility</p>
            </div>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <Icon name="Home" size={16} />
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>

      <main className="flex-1">
        <div className="p-4 lg:p-8">
          {/* Search Section */}
          <CompatibilitySearch
            selectedChemical={selectedChemical}
            selectedMaterial={selectedMaterial}
            onChemicalSelect={setSelectedChemical}
            onMaterialSelect={setSelectedMaterial}
          />

          {/* Tab Navigation */}
          <div className="border-b border-border mb-6">
            <div className="flex gap-1 overflow-x-auto">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary font-medium' :'border-transparent text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="hidden sm:inline">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="space-y-6">
            {activeTab === 'matrix' && (
              <CompatibilityMatrix
                selectedChemical={selectedChemical}
                selectedMaterial={selectedMaterial}
              />
            )}
            {activeTab === 'scenario' && (
              <ScenarioBuilder
                scenarioData={scenarioData}
                onScenarioChange={setScenarioData}
                selectedChemical={selectedChemical}
                selectedMaterial={selectedMaterial}
              />
            )}
            {activeTab === 'assessment' && (
              <AssessmentResults
                selectedChemical={selectedChemical}
                selectedMaterial={selectedMaterial}
                scenarioData={scenarioData}
              />
            )}
            {activeTab === 'references' && (
              <ReferenceLiterature
                selectedChemical={selectedChemical}
                selectedMaterial={selectedMaterial}
              />
            )}
          </div>
        </div>
      </main>
    </div>
  );
}